import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs";
import { DomainCodes } from "../../../models/const.DomainCodes";
import { DocumentVMExtension } from "../../workflows/cards/Documentation/IDocumentation";
import { CommonData } from "../../_infrastructure/CommonData/CommonDataResolver";
import { DocumentsHandlerService } from "../../_infrastructure/Documents/DocumentHandlerService";
import { isNullOrUndefined } from "../../_infrastructure/objectUtils";
import { SecurityService } from "../../_infrastructure/Security/SecurityService";
import { SubscriberInformationService } from "../../_infrastructure/SubscriberInfo/SubscriberInformationService";

@Component({
    selector: 'prestage-documentation',
    templateUrl: './prestage-documentation.component.html',
    styleUrls: ['./prestage-documentation.component.scss'],
    standalone: false
})

export class PreStageDocumentationComponent implements OnDestroy, OnInit, OnChanges {

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  public showAddDocButton: boolean = false;

  @Input()
  public workflowCode: string;
  @Input()
  public workflowInstanceId: number;
  @Input()
  public subscriberNumber: string;


  @Input()
  public isReadonly: boolean = false;


  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];
  @CommonData(DomainCodes.documentDesignationType)
  public designationTypes: models.DimensionVM[];

  @Output()
  public documentsListChanged: EventEmitter<models.DocumentVM[]> = new EventEmitter();
  @Input()
  public documentsList: models.DocumentVM[]=[];

  public dropdowns: models.WorkflowDropdownsVM;
  public initialMandatory: string[];
  private mainSubscription: Subscription;
  constructor(private http: HttpClient, private subscriberInfoService: SubscriberInformationService, private documentService: DocumentsHandlerService, private securityService: SecurityService) {
    this.mainSubscription = new Subscription();
    this.mainSubscription.add()
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.subscriberNumber) {
      this.subscriberInfoService.setCurrentSubscriber(parseInt(this.subscriberNumber), this.workflowInstanceId, this.workflowCode).subscribe(el => el);
    }
  }

  ngOnInit(): void {
    this.loadDropDowns();
  }

  onDocumentationChanged(newDocumentList: DocumentVMExtension[]) {

    // Refresh intitial mandatory list

    this.documentsList = newDocumentList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
    this.documentsListChanged.emit(this.documentsList);
  }

  GetItemDescription(designationTypeCode: string): string {
    if (this.dropdowns?.options !== null && this.dropdowns?.options !== undefined) {
      let options = this.dropdowns.options.find(el => el.value == designationTypeCode);
      if (!!options) {
        return options?.description;
      } else {
        return null;
      }
    }

  }


  public expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  downloadDocument(item: DocumentVMExtension, evt:Event) {
    if (!isNullOrUndefined(item.fileID) && item.fileID != "") {
      this.documentService.DownloadFile(item.fileID, item.fileName, this.workflowInstanceId.toString(), this.subscriberNumber);
    }
    //Cancel click event so it doesnt expand
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
      
  }

  loadDropDowns() {
    this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: 0, workflowCode: null} })
      .subscribe(result => {
        this.dropdowns = result;
        if (this.dropdowns.options.length == 0) {
          //default documents para prestage 
          this.dropdowns.options = [
            {
              "description": "Prova de efetividade de serviço",
              "dropdown": "dropListDocuments",
              "value": "MDP170",
              "type": "001"
            } as models.Options,
            {
              "description": "Outro meio de prova",
              "dropdown": "dropListDocuments",
              "value": "MDP130",
              "type": "001"
            } as models.Options,
          ]
        } else {
          this.dropdowns.options = this.dropdowns.options.filter(el => el.dropdown == 'dropListDocumentsPS');
        }
        this.initialMandatory = ["MDP170"];
        if (this.documentsList == undefined) {
          this.documentsList = [];
        }
        if (this.documentsList?.length == 0) {
          this.documentsList.push({
            designationTypeCode: "MDP170",
            isMandatoryFile: true,
            fileID:"0",
          } as DocumentVMExtension)
        }
      });
  }

  public markAsMandatory(docItem: DocumentVMExtension): boolean {
    return docItem.isMandatoryFile?.toString()?.toLowerCase() == 'true' && this.securityService.userDetails?.utente != "";
  }

  ngOnDestroy(): void {

  }

}
